import * as actionTypes from "../../constants/ActionTypes/AdminPortal/HardwareInclusiveCounter";

export const fetchHardwareInclusiveStockCounter = (countryCode,PrinterType) => ({
  type: actionTypes.GET_HARDWARE_INCLUSIVE_STOCK_COUNTER_INIT ,
  countryCode,
  PrinterType
});

export const addHardwareInclusiveCounter = (printerTypeId,availableUnits,countryCode,isEnabled) => ({
  type: actionTypes.ADD_HARDWARE_INCLUSIVE_COUNTER_INIT,
  printerTypeId,
  availableUnits,
  countryCode,
  isEnabled
});

export const updateHardwareInclusiveCounter = (printerTypeId,availableUnits,countryCode,isEnabled) => ({
  type: actionTypes.UPDATE_HARDWARE_INCLUSIVE_COUNTER_INIT,
  printerTypeId,
  availableUnits,
  countryCode,
  isEnabled
});

export const resetHardwareInclusiveCounterUpdate = () => ({
  type: actionTypes.UPDATE_HARDWARE_INCLUSIVE_COUNTER_RESET
});
export const resetHardwareInclusiveCounterFetch = () => ({
  type: actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_RESET
});
export const resetHardwareInclusiveCounterAdd = () => ({
  type: actionTypes.ADD_HARDWARE_INCLUSIVE_COUNTER_RESET
});